import { createFileRoute } from "@tanstack/react-router";

import { PLAN_QUERY } from "@/features/settings/plans/graphql/plan-query";
import { Plan } from "@/features/settings/plans/plan";

export const Route = createFileRoute("/_authenticated/settings/plans/$id")({
  component: Plan,
  loader: async ({ context, params }) => {
    if (context.urqlClient) {
      await context.urqlClient.query(PLAN_QUERY, { id: params.id }).toPromise();
    }
  },
});
